//Angular imports
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';

//RxJs imports
import { of } from 'rxjs';
import { share, tap } from 'rxjs/operators';

//Model imports
import { CacheEntry } from '../_models/cache-entry';

//Service imports
import { RPCacheRegistrationService } from '../_services/shared-services/rp-cache-registration-service';

@Injectable()
export class UriCachingInterceptor implements HttpInterceptor {
  constructor(private cacheRegistrationService: RPCacheRegistrationService) {}

  public intercept(httpRequest: HttpRequest<any>, handler: HttpHandler) {
    // Don't cache if
    // 1. It's not a GET request
    // 2. If URI is not supposed to be cached
    if (
      httpRequest.method !== 'GET' ||
      !this.cacheRegistrationService.isNeedToCache(httpRequest.url)
    ) {
      return handler.handle(httpRequest);
    }

    // Also leave scope of resetting already cached data for a URI
    if (httpRequest.headers.get('reset-cache')) {
      this.cacheRegistrationService.deleteCache(httpRequest.urlWithParams);
    }

    // Checked if there is cached data for this URI
    const lastResponse = this.cacheRegistrationService.getCacheEntry(
      httpRequest.urlWithParams
    );

    if (!!lastResponse && !!lastResponse.response) {
      return of(lastResponse.response.clone());
    }

    // If the request of going through for first time
    // then let the request proceed and cache the response
    const requestHandle = handler.handle(httpRequest).pipe(
      tap((stateEvent) => {
        if (stateEvent instanceof HttpResponse && stateEvent.ok) {
          const cacheEntry = new CacheEntry();
          cacheEntry.response = stateEvent.clone();
          cacheEntry.lastRead = Date.now();
          this.cacheRegistrationService.addToCache(
            httpRequest.urlWithParams,
            cacheEntry
          );
        }
      }),
      share()
    );

    return requestHandle;
  }
}
